import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

const colDefs = [
    {
        field: 'orderNumber',
        headerName: 'Order Number',
        sortable: true,
        filter: true,
        width: 100,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            return ( <Link to={`/${params.data.unitName}/order/information?ordernum=${params.value}`}>{params.value}</Link> );

        }
    },
    {
        field: 'constraintKey',
        headerName: 'Constraint',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'rdd',
        headerName: 'RDD',
        sortable: true,
        filter: true,
        width: 60,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            const dt = formatGivenDate( params.value, 'DDMMMYY' );
            return ( <span>{dt}</span> );

        }
    },
    {
        field: 'fdd',
        headerName: 'FDD',
        sortable: true,
        width: 60,
        filter: true,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            const dt = formatGivenDate( params.value, 'DDMMMYY' );
            return ( <span>{dt}</span> );

        }
    },
    {
        field: 'dateDifference',
        headerName: 'Day Difference',
        sortable: true,
        filter: true,
        width: 100
    },
    {
        field: 'retailIndicator',
        headerName: 'Retail Ind',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'earlyShipInd',
        headerName: 'Early Ship Ind',
        sortable: true,
        filter: true,
        width: 90
    },
    {
        field: 'creditCode',
        headerName: 'Credit Code',
        sortable: true,
        filter: true,
        width: 85
    },
    {
        field: 'salesProgram',
        headerName: 'Sales Program',
        sortable: true,
        filter: true,
        width: 100
    }
];

const FddPastRddTable = props => (

    <section className="atp-search-result-panel fdd-past-rdd-result-panel">

        {props.results && (
            <div id="results-message" className="results-message">
                {`${props.results.length} Results as of ${formatGivenDate( new Date(), 'DD MMM YY hh:mm:ss A' )}` }
            </div>
        )}

        <AgGridReactComponent
            reactNext={true}
            columnDefs={colDefs}
            rowData={props.results}
            onGridReady={onGridReady}
        />

    </section>
);
FddPastRddTable.propTypes = {
    results: PropTypes.array.isRequired
};

export default FddPastRddTable;
